<style scoped>
#new_payroll_header {
	background-color: rgb(252, 252, 252);
}
</style>

<template>
	<v-container id="new_payroll_header" fluid>
		<v-payroll-header-entry
			:payroll_header="payroll_header"
			:popup_editors="true"
		/>
	</v-container>
</template>

<script>
import PayrollHeader from "@/models/payroll/payroll_header"

import payroll_header_entry from "@/components/addressbook/payroll_header/payroll_header_entry"

export default {
	components: {
		'v-payroll-header-entry': payroll_header_entry,
	},
	data() {
		return {
			errormsg: '',
			payroll_header: new PayrollHeader(), // our payroll header
		}
	},
	mounted() {
		this.payroll_header.addressbook_id = this.$route.params.adbid;

		/* to keep document360-widget-iframe non-showing */
		/* TODO this should be centralised somewhere!!!! */
		const widget_name_str = 'beacon-container';
		const child = document.getElementById(widget_name_str);

		if (child) {
			child.style.display = 'none';
		}	else {
			const body_arr = document.getElementsByTagName('body');
			const target_node = body_arr[0];
			const config = { childList: true};
			let isIframe = false;

			const callback = (mutationsList) => {
				mutationsList.forEach((item) => {
					if (item.type == 'childList') {
						const childNodes = item.target.childNodes;
						childNodes.forEach(c => {
							if (c.id === widget_name_str) {
								isIframe = true;
								const child_new = document.getElementById(widget_name_str);
								child_new.style.display = 'none';
							}
						});
					}
				});
			};

			const observer = new MutationObserver(callback);
			observer.observe(target_node, config);
			if (isIframe) {
				observer.disconnect();
			}
		}
	},
}
</script>

